import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import Link from "next/link";
import PureHtml from "@/components/custom/PureHtml";
import { AspectRatio, Box, Button } from "@mantine/core";
import { mediaUrl } from "@/lib/config/app";
export default function VideoWithText(t0) {
  const $ = _c(17);
  const {
    svideo
  } = t0;
  const t1 = svideo?.heading;
  let t2;
  if ($[0] !== t1) {
    t2 = <h2 className="text-xl lg:text-2xl">{t1}</h2>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = svideo?.subtext;
  let t4;
  if ($[2] !== t3) {
    t4 = <PureHtml html={t3} />;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== svideo.button_link || $[5] !== svideo.button_text) {
    t5 = svideo?.button_text && <Link href={svideo.button_link}><Button size="lg" autoContrast={true} color="black" ff="heading" miw={175}>{svideo?.button_text}</Button></Link>;
    $[4] = svideo.button_link;
    $[5] = svideo.button_text;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t2 || $[8] !== t4 || $[9] !== t5) {
    t6 = <div className="rounded shadow bg-white p-2 text-center">{t2}{t4}{t5}</div>;
    $[7] = t2;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== svideo.heading || $[12] !== svideo.video_url) {
    t7 = <div className="rounded shadow bg-white p-2 text-center">{svideo.video_url ? <AspectRatio ratio={1.7777777777777777}><video controls={true} preload="metadata" className="w-full h-full object-cover"><source src={`${mediaUrl}${svideo.video_url}`} type="video/mp4" /><source src={`${mediaUrl}${svideo.video_url.replace(".mp4", ".webm")}`} type="video/webm" /><img src={`${mediaUrl}novideo.jpg`} alt="Video thumbnail" /></video></AspectRatio> : <Image src={`${mediaUrl}novideo.jpg`} alt={svideo?.heading || "Banner"} width={350} height={250} sizes="80vw" className="w-full" />}</div>;
    $[11] = svideo.heading;
    $[12] = svideo.video_url;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t6 || $[15] !== t7) {
    t8 = <Box className="side-video py-2 lg:py-3"><div className="max-w-7xl mx-auto px-2"><div className="grid grid-cols-1 lg:grid-cols-2 items-center justify-center gap-2">{t6}{t7}</div></div></Box>;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
}